// extracted by mini-css-extract-plugin
export default {"contentTitle":"Content_contentTitle__FhTYk","contentTitleHr":"Content_contentTitleHr__G0iQz","contentText":"Content_contentText__x3mFs"};